import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared';

// core2/platform/dm/applet-login-subject-link/create-multiple/{tenantCode}/tenant-ep

@Injectable({providedIn: 'root'})
export class AppLoginSubjectLinkPlatformService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-login-subject-link/create-multiple';
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + 'applet-login-subject-link/create-multiple';
    this.httpClient = http;
  }

  public createRecord(dtoObject: any, tenantCode: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode + '/tenant-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
